export function shouldShowMobileHeaderBrand(pathname: string): boolean {
  return (
    pathname === "/" ||
    /^\/listings\/?$/.test(pathname) ||
    /^\/listing\/[^/]+\/?$/.test(pathname)
  );
}

export function shouldUseMobileNavigationMenu(pathname: string): boolean {
  return (
    pathname === "/" ||
    /^\/listings\/?$/.test(pathname) ||
    /^\/listing\/[^/]+\/?$/.test(pathname)
  );
}

export interface MobileHeaderAction {
  kind: "account" | "home";
  label: string;
  to: string;
}

export function getMobileHeaderAction(
  pathname: string,
  isAuthenticated: boolean,
): MobileHeaderAction {
  if (shouldUseMobileNavigationMenu(pathname)) {
    return {
      kind: "account",
      label: isAuthenticated ? "Open profile" : "Sign in",
      to: isAuthenticated ? "/profile" : "/login",
    };
  }

  return {
    kind: "home",
    label: "Go home",
    to: "/",
  };
}
